import React, { useCallback, useReducer } from 'react';
import { confirm } from "react-confirm-box";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import { useNavigate,NavLink, Link } from 'react-router-dom';
import { ulmsUrl } from '../../Api';
import DataTable from 'react-data-table-component';
import Loader from '../../loader/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const MailConfigList = () => {

    const rolelisturl = '/config/mail_config_list';
    const statusUpdateurl = '/config/mail_config_status_update';

    const navigate = useNavigate();
    var base64 = require('base-64');
    const usr_token = localStorage.getItem('authToken');
    const isUserLogin = localStorage.getItem('isAuthenticatedUser');
    let message = sessionStorage.getItem("rolemessage");

    const [configList, setConfigList]  = React.useState([]);
    const [search ,setSearch]  = React.useState("");
    const [filteredConfig ,setFilteredConfig]  = React.useState([]);
    const [ isAlertVisible, setIsAlertVisible ] = React.useState(true);
    const [loading, setLoading] = useState(true);

    if(message){
        toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'success1',
        });
    }
   
    // const addRole = async () => {    
    //     navigate("/role_create");
    // }

    const getConfigData = async () => {
        setLoading(true);
              
        try {
            fetch(ulmsUrl.concat(rolelisturl) , {
                method: 'POST',
                body:JSON.stringify({usr_token}),
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response) =>
                response.json()
            )
            .then((response) => {  
                setLoading(false);
                let result = response.data;
                console.log(result)
                setConfigList(result)
                setFilteredConfig(result);
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() =>{
        getConfigData();
    }, []);

    const confirmstatusdialog = (data) => {

        confirmAlert({
            title: "Confirm to submit",
            message: "Are you sure you want to change the status?",
            buttons: [
              {
                label: "Yes",
                onClick: () => statusUpdate(data)
              },
              {
                label: "No"
                // onClick: () => alert("Click No")
              }
            ]
        });
    }
    const confirmdialog = (data) => {

        confirmAlert({
            title: "Confirm to submit",
            message: "Are you sure you want to change the status?",
            buttons: [
              {
                label: "Yes",
                onClick: () => whatsappStatusUpdate(data)
              },
              {
                label: "No"
                // onClick: () => alert("Click No")
              }
            ]
        });
    }

    const statusUpdate = async (id) => {
        console.log(JSON.stringify({id,usr_token}));
       
        fetch(ulmsUrl.concat(statusUpdateurl), {
            method: 'POST',
            body: JSON.stringify({id,usr_token}),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((result) =>
            result.json()
        )
        .then((result) => {
            console.log(result)
            if (result.status == true) {
                toast.success(result.message, {
                position: toast.POSITION.TOP_RIGHT,
                toastId: 'success1',
                });
                getConfigData();
        
            } else if (result.status == false) {
                toast.error(result.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: 'success1',
                });
            }
        })
        .catch((form_err) => {

        })
        
    }

    const whatsappStatusUpdate = async (id) => {
        console.log(JSON.stringify({id,usr_token}));
       
        fetch(ulmsUrl.concat('/config/whatsapp_config_status_update'), {
            method: 'POST',
            body: JSON.stringify({id,usr_token}),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((result) =>
            result.json()
        )
        .then((result) => {
            console.log(result)
            if (result.status == true) {
                toast.success(result.message, {
                position: toast.POSITION.TOP_RIGHT,
                toastId: 'success1',
                });
                getConfigData();
        
            } else if (result.status == false) {
                toast.error(result.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: 'success1',
                });
            }
        })
        .catch((form_err) => {

        })
        
    }

    useEffect(() => {
        const filterResult = configList.filter(data => {
            //  return (data.name?.toLowerCase().match(search?.toLowerCase()) || data.status?.toLowerCase().match(search?.toLowerCase()));  
        });
   
        setFilteredConfig(filterResult);
    }, [search]); 

    const columns = [
        { 
          name: "ID",
          selector : (row) => row.id,
          width : '200px',
          sortable :  true
        },
        {
          name: "Title",
          width : '300px',
          sortable :  true,    
          selector : (row) => row.mail_title,     
        },
        {
            name: "Mail Status",
            width : '300px',
            sortable :  true,  
            selector : (row) =>  {
                return(
                  <div>
                    <>
                    {row.status == '0' &&
                        <Link onClick={()=>confirmstatusdialog(row.id)} title="Click to Active" ><span className='badge bg-danger' >Inactive</span></Link> 
                    }
                    {row.status == '1' && 
                        <Link onClick={()=>confirmstatusdialog(row.id)} title="Click to Inactive" ><span className='badge bg-primary' >Active</span></Link> 
                    }
                    </>
                  </div>
                )
            }
        },
        {
            name: "Whatsapp Status",
            width : '300px',
            sortable :  true,  
            selector : (row) =>  {
                return(
                  <div>
                    {row.id != '1' ?
                    <>
                    {row.whatsapp_status == '0' &&
                        <Link onClick={()=>confirmdialog(row.id)} title="Click to Active" ><span className='badge bg-danger' >Inactive</span></Link> 
                    }
                    {row.whatsapp_status == '1' && 
                        <Link onClick={()=>confirmdialog(row.id)} title="Click to Inactive" ><span className='badge bg-primary' >Active</span></Link> 
                    }
                    </> :
                     <div >Not Applicable</div> 
                    }

                  </div>
                )
            }
        },
        // {
        //     name: "Action",
        //     width : '150px',
        //     cell : (row) => 
        //     {
        //         return(
        //           <div>
        //             <Link to={`/role_update/${base64.encode(row.id)}`} ><span className='badge bg-primary' >EDIT</span></Link> &nbsp;&nbsp;&nbsp;
        //           </div>
        //         )
        //     }
        // }, 
        
    ];

    useEffect(() => {
        if(message != ''){
            setTimeout(() => {
            setIsAlertVisible(false);
            sessionStorage.removeItem('rolemessage');
            }, 8000);    
        }
    }, []); 

  return (
            <>
            <ToastContainer />
            {loading && (
                <>
                <Loader/>
                </>
            )}
            <div className="row">
                <div className="order-2 order-lg-1 col-lg-12 bd-content">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title" style={{float:'left'}}>Mail and Whatsapp Config</h3>    
                            {/* <button style={{font_size: '12px', float: 'right'}} type="button" onClick={addRole} className="btn btn-primary btn-sm  me-2"><strong> Add M Config</strong></button> */}
                            <CSVLink style={{font_size: '12px', float: 'right'}} className="btn btn-success btn-sm  me-2" 
                            data={filteredConfig}
                            filename={"Roles.csv"}
                            >Export</CSVLink>
                        </div>
                        
                        <div className="card-body">         
                            <DataTable 
                                id="table-to-xls"
                                data={filteredConfig} 
                                columns={columns} 
                                pagination
                                fixedHeader
                                highlightOnHover
                                subHeader
                                subHeaderComponent = {
                                <div className="col-md-3" style={{float:'right'}}>
                                <input type="text" 
                                placeholder='Search here' 
                                className='w-22 form-control'
                                value={search}
                                onChange={(e)=> setSearch(e.target.value)}
                                />
                                </div>
                                }
                            />
                            
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>

                        </div>
                    </div>
                </div>
            </div>
        </>
  )
}

export default MailConfigList